import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILibrary, ILibraryListReqBody, IInitState } from "../interfaces";
import { getItem } from "utils/helpers";

const libraryFilters = getItem("libraryFilters");
const initialState = {
  loading: false,
  data: [],
  error: "",
  filtersData: libraryFilters ? libraryFilters : "",
};

const libraryListSlice = createSlice({
  name: "libraryList",
  initialState,
  reducers: {
    libraryListRequest(
      state: IInitState,
      action: PayloadAction<ILibraryListReqBody>
    ) {
      state.loading = true;
      state.filtersData = action.payload;
    },
    libraryListSuccess(state: IInitState, action: PayloadAction<ILibrary[]>) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { libraryListRequest, libraryListSuccess } =
  libraryListSlice.actions;
export default libraryListSlice.reducer;
